import { useContext } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import formatearValores from "../../helpers/formatearAPeso";
import { calcularMetricasAnalisis } from "../../helpers/metricasAnalisis";

const DatosAnalisis = ({ datosBack }) => {
  const { darkMode } = useContext(DarkModeContext);

  // Misma fuente de verdad que las tablas "Composicion de las ventas" y
  // "Ventas en cuotas".
  const { debito, unPago, enCuotas, cantidadOperaciones } =
    calcularMetricasAnalisis(datosBack);

  const valoresFormateados = formatearValores(debito, unPago, enCuotas);

  const cards = [
    {
      label: "Cantidad de Operaciones",
      value: cantidadOperaciones,
    },
    {
      label: "Débito",
      value: `$ ${valoresFormateados[0]}`,
    },
    {
      label: "1 Pago",
      value: `$ ${valoresFormateados[1]}`,
    },
    {
      label: "Cuotas",
      value: `$ ${valoresFormateados[2]}`,
    },
  ];

  return (
    <section className="container">
      <div className="row">
        {cards.map((card) => (
          <article className="col-12 col-md-6 col-lg-3 py-2" key={card.label}>
            <button
              className={
                darkMode
                  ? "bg-data-dark border-0 quitar-cursor-pointer"
                  : "container-light bg-data border-0 quitar-cursor-pointer"
              }
            >
              <div className="d-flex justify-content-center border-0 lato-bold-a-lato-500 fs-22">
                {card.value}
              </div>
              <h6 className="text-center lato-bold fs-17">{card.label}</h6>
            </button>
          </article>
        ))}
      </div>
    </section>
  );
};

export default DatosAnalisis;
